import jQuery from "jquery";
import { HTML_ELEMENT } from './globals.js';
import { trapFocus } from "./vendor/trapFocus.js";

const TAKEOVER_MENU = document.querySelector('.c-global-nav');
const DESKTOP_MENU_TOGGLE = document.querySelector('.c-menu-trigger--desktop');
const MOBILE_MENU_TOGGLE = document.querySelector('.c-menu-trigger--mobile');
const desktopMenuToggleLabel = document.querySelector('.c-menu-trigger--desktop .c-menu-trigger__label');
const mobileMenuToggleLabel = document.querySelector('.c-menu-trigger--mobile .c-menu-trigger__label');
const headerFocusableWrappers = document.querySelectorAll('.js-trap-focus');


let isMenuShown = false;

(function() {

    if(DESKTOP_MENU_TOGGLE) {
        DESKTOP_MENU_TOGGLE.addEventListener("click", function(e) {
            toggleMenuVisibility(!isMenuShown);
        })
    }
    if(DESKTOP_MENU_TOGGLE) {
        MOBILE_MENU_TOGGLE.addEventListener("click", function(e) {
            toggleMenuVisibility(!isMenuShown);
        })
    }
    
}());

function toggleMenuVisibility(value) {

    isMenuShown = value;

    HTML_ELEMENT.classList.toggle("state--nav-open", value);
    DESKTOP_MENU_TOGGLE.setAttribute("aria-expanded", value);
    MOBILE_MENU_TOGGLE.setAttribute("aria-expanded", value);
    desktopMenuToggleLabel.textContent = (value ? 'Close' : 'Menu');
    mobileMenuToggleLabel.textContent = (value ? 'Close' : 'Menu');
    trapFocus(headerFocusableWrappers, value ? MOBILE_MENU_TOGGLE : null);

}


// Main navigation Submenus

$('.c-global-nav__rhs .sub-menu').addClass('is-hidden');

$('.c-global-nav .menu-item-description').each(function() {
    const $parent = $(this).parent().parent();
    $(this).appendTo($parent);
});

$('.c-global-nav__rhs .menu-item-has-children > a').each(function(){
    $(this).after('<button class="c-main-menu__submenu-toggle" aria-expanded="false"><i aria-hidden="true" class="fal fa-angle-down"></i><span class="u-hidden-visually">Open menu for ' + $(this).text() + '</span></button>');
});

$('.c-global-nav__rhs .menu-item-has-children').on('click', 'button', function() {
    $(this).next().toggleClass('is-hidden');
    $(this).toggleAttrVal('aria-expanded', 'true', 'false');
});

// Footer menu description adjustment

$('.c-global-footer__nav-list--venues .menu-item-description').each(function() {
    const $parent = $(this).parent().parent();
    $(this).appendTo($parent);
});

// Attribute toggle helper functions

$.fn.toggleAttr = function(attr) {
    return this.each(function() {
      var self = $(this);
          if (self.is('['+attr+']')) {
          self.removeAttr(attr)
      }else{
        self.attr(attr,1)
      }
    });
};

// jquery toggle just the attribute value
$.fn.toggleAttrVal = function(attr, val1, val2) {
    var test = $(this).attr(attr);
    if ( test === val1) {
      $(this).attr(attr, val2);
      return this;
    }
    if ( test === val2) {
      $(this).attr(attr, val1);
      return this;
    }
    // default to val1 if neither
    $(this).attr(attr, val1);
    return this;
};


export { toggleMenuVisibility };